import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';

type FormInputHelpButtonProps = {
    id: string;
    label?: string;
    helpText: string;
};

const FormInputHelpButton = React.memo(FormInputHelpButtonMemo);

function FormInputHelpButtonMemo({
    id,
    label,
    helpText
}: FormInputHelpButtonProps) {
    return (
        <>
            <div
                id={`help-${id}`}
                aria-label={`help-${label}`}
                className='card-header header-right'>
                <FontAwesomeIcon icon={faInfo} />
            </div>
            <UncontrolledPopover
                trigger='legacy'
                id='help-tooltip'
                placement='auto'
                target={`help-${id}`}>
                <PopoverBody>{helpText}</PopoverBody>
            </UncontrolledPopover>
        </>
    );
}

export default FormInputHelpButton;
